var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19C5.5 18.4477 5.94772 18 6.5 18H88.5C89.0523 18 89.5 18.4477 89.5 19V89C89.5 89.5523 89.0523 90 88.5 90H6.5C5.94772 90 5.5 89.5523 5.5 89V19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13H88.5C91.8137 13 94.5 15.6863 94.5 19V89C94.5 92.3137 91.8137 95 88.5 95H6.5C3.1863 95 0.5 92.3137 0.5 89V19C0.5 15.6863 3.18629 13 6.5 13ZM6.5 18C5.94772 18 5.5 18.4477 5.5 19V89C5.5 89.5523 5.94772 90 6.5 90H88.5C89.0523 90 89.5 89.5523 89.5 89V19C89.5 18.4477 89.0523 18 88.5 18H6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4751 73.1044C38.5276 73.1044 32.8955 67.4723 32.8955 60.5249C32.8955 53.5774 38.5276 47.9453 45.4751 47.9453C52.4225 47.9453 58.0546 53.5774 58.0546 60.5249C58.0546 63.3938 57.0942 66.0385 55.4773 68.1548L62.0197 74.6971C62.6747 75.3521 62.6747 76.4141 62.0197 77.0691C61.3646 77.7242 60.3026 77.7242 59.6476 77.0691L53.1053 70.5269C50.9889 72.1439 48.3442 73.1044 45.4751 73.1044ZM45.4749 69.7499C50.5697 69.7499 54.6999 65.6198 54.6999 60.5249C54.6999 55.4301 50.5697 51.2999 45.4749 51.2999C40.3801 51.2999 36.25 55.4301 36.25 60.5249C36.25 65.6198 40.3801 69.7499 45.4749 69.7499Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 35.999H89.5V18.999C89.5 18.4467 89.0523 17.999 88.5 17.999H6.5C5.94772 17.999 5.5 18.4467 5.5 18.999V35.999Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 18C25.6193 18 24.5 16.8807 24.5 15.5L24.5 2.5C24.5 1.11929 25.6193 -4.89257e-08 27 -1.09279e-07C28.3807 -1.69632e-07 29.5 1.11929 29.5 2.5L29.5 15.5C29.5 16.8807 28.3807 18 27 18Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 18C73.6193 18 72.5 16.8807 72.5 15.5L72.5 2.5C72.5 1.11929 73.6193 -4.89257e-08 75 -1.09279e-07C76.3807 -1.69632e-07 77.5 1.11929 77.5 2.5L77.5 15.5C77.5 16.8807 76.3807 18 75 18Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.56c72c08.svg";
export { ForwardRef as ReactComponent };